import axios from '../../axios'

/*
 * 用户管理模块
 */

// 保存
export const save = (data) => {
    return axios({
        url: '/category/save',
        method: 'post',
        data
    })
}
// 删除
export const batchDelete = (data) => {
    return axios({
        url: '/category/delete',
        method: 'post',
        data
    })
}
// 分页查询
export const findPage = (data) => {
    return axios({
        url: '/category/list',
        method: 'post',
        data
    })
}
// 分页查询
export const detailView = (data) => {
    return axios({
        url: '/category/detail',
        method: 'post',
        data
    })
}
// 分页查询
export const listAllCms = (data) => {
  return axios({
    url: '/category/listAll',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/http/modules/cms/category.js